import { render, staticRenderFns } from "./InvoiceMXDetail.vue?vue&type=template&id=9fb64568&scoped=true"
import script from "./InvoiceMXDetail.vue?vue&type=script&lang=js"
export * from "./InvoiceMXDetail.vue?vue&type=script&lang=js"
import style0 from "./InvoiceMXDetail.vue?vue&type=style&index=0&id=9fb64568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb64568",
  null
  
)

export default component.exports